import src from "IMAGE";
export default { src, width: 3680, height: 786, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42h2HAQrAIAwD/f/3tqHBbm2dRf2FQcKRu+Sjoc2Of8V5DYcRDcPXFSlLgfjLMFQT3NxDcqWVCxsyDTc+lDjWoAAAAABJRU5ErkJggg=="};
